var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 628,
    height: 179,
    viewBox: "0 0 628 179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M85 0h146v171H85z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "109.6%",
    height: "108.2%",
    x: "-4.8%",
    y: "-2.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M241 0h146v171H241z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "109.6%",
    height: "108.2%",
    x: "-4.8%",
    y: "-2.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M397 0h146v171H397z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "109.6%",
    height: "108.2%",
    x: "-4.8%",
    y: "-2.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9DCE1",
    fillRule: "nonzero",
    d: "M0 133h85v40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6FB",
    fillRule: "nonzero",
    d: "M628 133h-85v40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9DCE1",
    fillRule: "nonzero",
    d: "M156 133h85v40zM312 133h85v40z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D61020",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D61020",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D61020",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M475.3 101.26V83.108c0-3.025.12-7.417.362-13.174.242-5.756.436-9.1.58-10.027h-.58a81.967 81.967 0 0 1-6.46 11.71l-19.456 29.641h25.553zm34.7 17.564h-12.777V141h-21.924v-22.176H430v-15.735L476.533 34h20.69v67.26H510v17.564zM163.3 101.26V83.108c0-3.025.12-7.417.362-13.174.242-5.756.436-9.1.58-10.027h-.58a81.967 81.967 0 0 1-6.46 11.71l-19.456 29.641h25.553zm34.7 17.564h-12.777V141h-21.924v-22.176H118v-15.735L164.533 34h20.69v67.26H198v17.564zM298.83 87.609c0 12.99 1.152 22.295 3.458 27.92 2.305 5.625 6.183 8.437 11.637 8.437 5.355 0 9.222-2.848 11.601-8.546 2.38-5.697 3.57-14.967 3.57-27.811 0-12.989-1.203-22.318-3.607-27.992-2.405-5.673-6.26-8.51-11.564-8.51-5.404 0-9.27 2.837-11.6 8.51-2.332 5.674-3.495 15.003-3.495 27.992m53.17 0c0 18.493-3.112 32.182-9.333 41.064-6.222 8.885-15.802 13.327-28.742 13.327-12.543 0-22-4.587-28.37-13.76-6.37-9.174-9.555-22.717-9.555-40.631 0-18.685 3.097-32.458 9.295-41.318 6.197-8.86 15.74-13.291 28.63-13.291 12.543 0 22.024 4.636 28.445 13.906 6.42 9.27 9.63 22.84 9.63 40.703"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4cecb446c3fd5b3746ca94d0c9cd7da7.svg";
export { ForwardRef as ReactComponent };